export enum RouteEnum {
  LOCATION = '/contact-us/location',
  SELECTALOCATION = '/locations',
  TOPICS = '/contact-us/topics',
  EXPERIENCE = '/contact-us/experience',
  CONTACT_INFO = '/contact-us/contact-info',
  ORDER_PROBLEM = '/contact-us/order-problem',
  ORDER_SUGGESTION = '/contact-us/order-suggestion',
  ORDER_EXPERIENCE = '/contact-us/experience',
  SUMMARY = '/contact-us/summary',
  THANKS = '/contact-us/thanks',
  LOCATIONS = '/locations',
  ADDVISIT = '/visits/add',
  VISITEXIST = '/visits/exists',
  VISIT_ADDED = '/visits/added',
  HOME = '/home',
  DESKTOP_NOTIFICATION_SETTINGS = '/account/settings/d/notifications'
}
